import React from "react";
import Typography from '@mui/material/Typography';
import './Contact.scss';
import ContactDetails from "../ContactDetails/ContactDetails";
import ContactForm from "../ContactForm/ContactForm";

const Contact = () => {
    return (
        <div id="contact">
            <div className="container">

                <Typography variant="h3" gutterBottom component="div" className="text-center main-heading">
                    Keep in Touch
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center mini-heading">
                    Speak to me if you have any questions.
                </Typography>

                <div className="row">
                    <div className="col-md-5">
                        <ContactDetails />
                    </div>
                    <div className="col-md-7 d-flex align-items-center">
                        <ContactForm />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Contact;